import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface IndustryFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const IndustryFilter = ({
  value = [],
  onChange,
  t,
}: IndustryFilterProps) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_industry")}
      example={t("filter_industry_example")}
      type="industry"
      value={value}
      onChange={onChange}
      limit={500}
    />
  );
};
